import { render, staticRenderFns } from "./shopCreateFeeList.vue?vue&type=template&id=ddf76f16&scoped=true"
import script from "./shopCreateFeeList.vue?vue&type=script&lang=js"
export * from "./shopCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./shopCreateFeeList.vue?vue&type=style&index=0&id=ddf76f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf76f16",
  null
  
)

export default component.exports